import React, { Component } from "react";
import { Grid } from "semantic-ui-react";
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';

class SearchResults extends Component {

  handeInputData = name => event => this.setState({ [name]: event.target.value }, () => this.setSearch())

  setSearch = () => {
    const dataValues = this.props.data
    let all = dataValues
    let results = []
    all.forEach((e) => {
      let found = 0
      let keys = Object.keys(e)
      keys.forEach((key) => {
        if ((e[key] ? (e[key] + '').toLowerCase().indexOf(this.state.search.toLowerCase()) : -1) >= 0) found += 1
      })
      if (found !== 0) results.push(e)
    })
    this.props.filter(results)
  }

  render() {
    return (
      <Grid.Row>
        <Grid.Column style={this.props.styles ? this.props.styles : { marginLeft: '15px' }} width={this.props.width}>
          <InputGroup>
            <InputGroupAddon addonType="prepend" >Buscar</InputGroupAddon>
            <Input
              onChange={this.handeInputData('search')} />
          </InputGroup>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default SearchResults;
